<template>
  <touch-member-party-part v-if="visible && env.touch" :part="part" :data="data" :readonly="readonly" :viewmode="viewmode"></touch-member-party-part>
  <mouse-member-party-part v-else-if="visible" :part="part" :data="data" :readonly="readonly" :viewmode="viewmode"></mouse-member-party-part>
</template>

<script setup lang="ts">
import {type PartProps, partProps} from "../../Part";
import useEditor from "../Editor";
import {injectEnv} from "../../Environment";
import TouchMemberPartyPart from "./TouchMemberPartyPart.vue";
import MouseMemberPartyPart from "./MouseMemberPartyPart.vue";

const uprops = defineProps({ ...partProps });
const props = uprops as PartProps;

const { visible, value, clazz, style, ro } = useEditor(props);
const env = injectEnv();
</script>

<style>
</style>
